const section_Ix = {
    656508: 265900,
    656510: 265900,
    1086510: 956100,
    1586510: 2302000,
    2086510: 4138000,
    SB6565: 265900,
    SB10865: 956100,
    SB15865: 2302000,
    SB20865: 4138000,
    FL10011: 347000,
    FL15015: 1256000,
    FL20020: 3374000,
};

export const calculateDeckBeamCapacity = (
    type, // "JOIST", "BEARER"
    section,
    span_mm,
    load_width_mm
) => {
    let Ix = section_Ix?.[section] ? section_Ix[section] : 0;
    if (Ix === 0) return false;

    let G = (0.6 * load_width_mm) / 1000;
    let Q_UDL = (2 * load_width_mm) / 1000;
    let Q_P = 1.8;
    // let M1_UDL = (1.2 * G * (span_mm / 1000)) ^ (2 / 8 + 1.5 * Q_UDL * (span_mm / 1000)) ^ (2 / 8);
    // let M2_P = (1.2 * G * (span_mm / 1000)) ^ (2 / 8 + (1.5 * Q_P * span_mm) / 1000 / 4);

    let Delta_G_mm = (5 * G * Math.pow(span_mm, 4)) / 384 / 200000 / Ix;

    let ratio_G = span_mm / Delta_G_mm;
    let capacity_G = (type == "Bearer" ? 600 : 500) / ratio_G;

    let Delta_Q_UDL_mm = (5 * Q_UDL * Math.pow(span_mm, 4)) / 384 / 200000 / Ix;
    let ratio_Q_UDL = span_mm / Delta_Q_UDL_mm;
    let capacity_Q_UDL = 400 / ratio_Q_UDL;

    let Delta_Q_P_mm = (Q_P * 1000 * Math.pow(span_mm, 3)) / 48 / 200000 / Ix;
    let ratio_Q_P = span_mm / Delta_Q_P_mm;
    let capacity_Q_P = 400 / ratio_Q_P;

    let Delta_G_04Q_mm = Delta_G_mm + 0.4 * Delta_Q_UDL_mm;
    let ratio_G_04Q = span_mm / Delta_G_04Q_mm;
    let capacity_G_04Q_mm = 400 / ratio_G_04Q;

    // if (window.debug) deckEngineering_test();

    return {
        ratio_G: ratio_G,
        capacity_G: capacity_G,
        ratio_Q_UDL: ratio_Q_UDL,
        capacity_Q_UDL: capacity_Q_UDL,
        ratio_Q_P: ratio_Q_P,
        capacity_Q_P: capacity_Q_P,
        ratio_G_04Q: ratio_G_04Q,
        capacity_G_04Q_mm: capacity_G_04Q_mm,
        capacity_max: Math.max(capacity_G, capacity_Q_UDL, capacity_Q_P, capacity_G_04Q_mm),
    };
};

export const calculateDeckLoadFromM2 = (floor_area_m2, roof_area_m2 = 0) => {
    let floor_weight_G_floormin = 0.3;
    let floor_weight_G_floormax = 0.6;
    let roof_weight_G_roof = 0.15;
    let live_load_Q_floor = 2.0;
    let live_load_Q_roof = 0.25;
    let load0point9G = 0.9 * floor_weight_G_floormin * floor_area_m2 + 0.9 * roof_weight_G_roof * roof_area_m2;

    let load1point2Gplus1point5Q =
        1.2 * (roof_area_m2 * roof_weight_G_roof + floor_weight_G_floormax * floor_area_m2) +
        1.5 * (live_load_Q_roof * roof_area_m2 + live_load_Q_floor * floor_area_m2);

    return load1point2Gplus1point5Q;
};

const column_sections = {
    "65mm x 65mm x 3mm P/C": {
        Grade: 450,
        A: 721,
        Ix: 4.54e5,
        Zex: 16600,
        Kf: 1,
    },
    "75mm x 75mm x 3mm P/C": {
        Grade: 450,
        A: 841,
        Ix: 7.16e5,
        Zex: 22200,
        Kf: 1,
    },
    "100mm x 100mm x 3mm P/C": {
        Grade: 450,
        A: 1140,
        Ix: 1.77e6,
        Zex: 34400,
        Kf: 0.952,
    },
};

export const calculate_ColCapacity = (section, height, floor_area_m2, roof_area_m2 = 0) => {
    let E23_load_case_1_kN = calculateDeckLoadFromM2(floor_area_m2, roof_area_m2);

    let G23_Eccentricity_ex = 110;

    let column_section_properties = column_sections[section];
    if (column_section_properties === null) return 99999;
    //section properties
    let E6_steel_grade = column_section_properties.Grade;
    let B11_A = column_section_properties.A;
    let B12_Ix = column_section_properties.Ix;
    let B13_Zex = column_section_properties.Zex;
    let B14_r = Math.pow(B12_Ix / B11_A, 0.5);
    let B15_kf = column_section_properties.Kf;
    let B16_Lx = height;
    let B17_Ly = height;

    let F16_Ix = 1 * B16_Lx;
    let F17_Iy = 1 * B17_Ly;

    let C32_Nstar = E23_load_case_1_kN;
    let C33_lambda_n = (Math.max(F16_Ix, F17_Iy) / B14_r) * Math.pow(B15_kf, 0.5) * Math.pow(E6_steel_grade / 250, 0.5);
    let C34_alpha_a = (2100 * (C33_lambda_n - 13.5)) / (Math.pow(C33_lambda_n, 2) - 15.3 * C33_lambda_n + 2050);
    let C35_alpha_b = -0.5;
    let C36_lambda = C33_lambda_n + C34_alpha_a * C35_alpha_b;
    let C37_n = Math.max(0, 0.00326 * (C36_lambda - 13.5));
    let C38_beta = (Math.pow(C36_lambda / 90, 2) + 1 + C37_n) / (2 * Math.pow(C36_lambda / 90, 2));
    let C39_alpha_c = Math.min(1, C38_beta * (1 - Math.pow(1 - Math.pow(90 / (C38_beta * C36_lambda), 2), 0.5)));
    let C40_phi_compression = 0.9;
    let C42_phi_nc = (C40_phi_compression * C39_alpha_c * B15_kf * B11_A * E6_steel_grade) / 1000;
    let C46_Mstarm = (E23_load_case_1_kN * G23_Eccentricity_ex) / 1000;
    let C47_cm = 1;
    let C48_Nomb = (Math.pow(Math.PI, 2) * 200000 * B12_Ix) / Math.pow(F16_Ix, 2) / 1000;
    let C49_delta_b = Math.max(1, C47_cm / (1 - C32_Nstar / C48_Nomb));
    let C50_M_star = C46_Mstarm * C49_delta_b;
    let C51_phi_bending = 0.9;
    let C52_phi_Msx = (C51_phi_bending * B13_Zex * E6_steel_grade) / Math.pow(10, 6);
    let C56_phi_Mix = Math.max(0, C52_phi_Msx * (1 - C32_Nstar / C42_phi_nc));

    console.log(
        "deck calculate_ColCapacity",
        C32_Nstar,
        C33_lambda_n,
        C34_alpha_a,
        C35_alpha_b,
        C36_lambda,
        C37_n,
        C38_beta,
        C39_alpha_c,
        C40_phi_compression,
        C42_phi_nc,
        C46_Mstarm,
        C47_cm,
        C48_Nomb,
        C49_delta_b,
        C50_M_star,
        C51_phi_bending,
        C52_phi_Msx,
        C56_phi_Mix
    );

    let capacity_ratio = C50_M_star / C56_phi_Mix;

    return capacity_ratio;
};

const PI = () => {
    return Math.PI;
};
const TAN = (radians) => {
    return Math.tan(radians);
};
const ABS = (double) => {
    return Math.abs(double);
};

const soil_types = {
    A: "A",
    B: "B",
    C: "C",
};

const soil_data = {
    A: {
        angle: 35,
        cohesion_kPa: 0,
        ultimate_bearing_capacity_kPa: 80,
    },
    B: {
        angle: 25,
        cohesion_kPa: 5,
        ultimate_bearing_capacity_kPa: 150,
    },
    C: {
        angle: 15,
        cohesion_kPa: 10,
        ultimate_bearing_capacity_kPa: 200,
    },
};

export const calculate_FootingCapacity = (
    load_at_base_of_col_kN,
    circular, //if true, otherwise square
    F19_width, // diameter if circular
    F22_depth,
    soil_type, // A coarse/sand, B silt/fine sand/granular soil with some clay, C stiff clay
    load_case_type = "1.2G+1.5Q" // "0.9G+Wu" or "1.2G+1.5Q" (default)
) => {
    let concrete_grade_mPa = 20,
        Fc = concrete_grade_mPa;
    let Adhesion = 0;
    let y_kn_m3 = 19,
        γ = y_kn_m3;
    let depth_of_ineffective_soil_mm = 100,
        Dineff = depth_of_ineffective_soil_mm,
        B6 = depth_of_ineffective_soil_mm;
    let ø = soil_data[soil_type].angle;
    let ultimate_bearing_capacity_kPa = soil_data[soil_type].ultimate_bearing_capacity_kPa;
    let Cohesion = soil_data[soil_type].cohesion_kPa,
        cohesion_kpa = Cohesion;
    let Kp = Math.pow(Math.tan((Math.PI * (45 + ø / 2)) / 180), 2);
    let Ka = Math.pow(Math.tan(((45 - ø / 2) * Math.PI) / 180), 2);
    let Tanø = TAN((PI() * ø) / 180);

    let F24_underream = 0;

    // calculated_params
    let F31_actual_base_diameter = F19_width,
        F31 = F31_actual_base_diameter,
        actual_base_diameter = F31_actual_base_diameter;
    let effective_depth = F22_depth - depth_of_ineffective_soil_mm,
        De = effective_depth;
    let area = circular ? (Math.PI * Math.pow(actual_base_diameter, 2)) / 4 : Math.pow(actual_base_diameter, 2),
        A = area;
    let z = circular ? (Math.PI * Math.pow(actual_base_diameter, 2)) / 4 : Math.pow(100, 3) / 6,
        F34 = z,
        Z = z;

    // ULTIMATE LOAD CASES AT BASE OF COLUMN - 1.2G+1.5Q is default case load
    let Fx_kN = 0,
        Fx = Fx_kN;
    let Fy_kN = load_at_base_of_col_kN,
        Fy = Fy_kN;
    let Mz_kN = 0,
        Mz = Mz_kN;
    let Tortion_kNm = 0;
    let F37_ground_slab_thickness_mm = 0.1,
        F37 = F37_ground_slab_thickness_mm;
    let F39_ground_slab_effective_area_m2 = 0,
        F39 = F39_ground_slab_effective_area_m2;

    if (load_case_type == "0.9G+Wu") {
    }

    // TANSLATE_PARAMS_TO_EXCEL
    let F22 = F22_depth;
    let D = F22;
    let F19 = F19_width,
        L = F19_width,
        B = F19_width;
    let F46 = Fy_kN;

    // UPLIFT CHECK
    let F57_pad_vol_m3 = circular
            ? (((((1 / 3) * PI()) / 4) * (Math.pow(F31_actual_base_diameter, 3) - Math.pow(F19_width, 3))) / 2 +
                  (PI() / 4) * Math.pow(F19_width, 2) * (F22_depth - (F31_actual_base_diameter - F19_width) / 2)) /
              Math.pow(10, 9)
            : (Math.pow(F19_width, 2) * F22_depth * 1) / Math.pow(10, 9) +
              ((F19_width + (F31_actual_base_diameter - F19_width) / 2) *
                  2 *
                  Math.pow(F31_actual_base_diameter - F19_width, 2)) /
                  Math.pow(10, 9),
        F57 = F57_pad_vol_m3;
    let F58_g_pad_kN = F57_pad_vol_m3 * 24,
        F58 = F58_g_pad_kN;
    let F59_soil_vol_m3 = circular
            ? (Math.pow(2 * (F22 + F31 / (2 * Tanø)) * Tanø, 2) * PI() * (F22 + F31 / (2 * Tanø))) /
                  Math.pow(10, 9) /
                  12 -
              (Math.pow(F31, 2) * PI() * (F31 / (2 * Tanø))) / 12 / Math.pow(10, 9) -
              F57
            : (F31 * Tanø * Math.pow(F22, 2) * 2 + (PI() * Math.pow(F22 * Tanø, 2) * F22) / 3) / Math.pow(10, 9),
        F59 = F59_soil_vol_m3;
    let F60_g_soil_wedge_kN = F59 * γ,
        F60 = F60_g_soil_wedge_kN;

    let F61_cp_kN = (PI() * F19 * F22 * 10) ^ ((-6 * Cohesion) / 2),
        F61 = F61_cp_kN;
    let F62_g_slb_kN = F37 * F39 * 0.024,
        F62 = F62_g_slb_kN;

    let F63_øG_max_kN = 0.9 * Math.max(F58 + F60 + F62, F58 + F61 + F62),
        F63 = F63_øG_max_kN;

    // OVERTURNING CHECK
    let F66_Mo_about_pier_base = ABS((Fx * D) / 1000 + Mz),
        F66 = F66_Mo_about_pier_base;

    // Moment resistance from passive earth pressure
    let F68_PPs_kpa = 4 * Cohesion + (Kp * γ * Dineff) / 1000,
        F68 = F68_PPs_kpa;
    let F69_PPb_kpa = (Kp * γ * De) / Math.pow(10, 3) + F68,
        F69 = F69_PPb_kpa;
    let F70_DZ_mm =
            F37_ground_slab_thickness_mm == 0
                ? ((((F68 + F69) / 2) * De * L) / Math.pow(10, 6) - Math.abs(Fx)) / ((F69 * L) / Math.pow(10, 6))
                : 0,
        F70 = F70_DZ_mm;
    let F71_Z = De - F70,
        F71 = F71_Z;
    let F72_PPz = (Kp * γ * F71) / Math.pow(10, 3) + F68,
        F72 = F72_PPz;
    let F73_x = (F70 * F69) / (F69 + F72),
        F73 = F73_x;
    let F75_F2 = (F69 * F73 * L) / 2 / Math.pow(10, 6),
        F75 = F75_F2;
    let F76_D_D = ((2 * F75) / F69) * 1000,
        F76 = F76_D_D;
    let F77_Depth_to_contraflex = De - F76,
        F77 = F77_Depth_to_contraflex;
    let F78_Mr_passive_earth_pressure = Math.max(
            0,
            ((((((F68 + F69) / 2) * De * (2 * F68 + F69)) / (3 * (F68 + F69))) * De - (F69 * Math.pow(F70, 2)) / 3) *
                L) /
                Math.pow(10, 9)
        ),
        F78 = F78_Mr_passive_earth_pressure;

    // Moment resistance from cohesion on sides of soil wedge
    // Above point of contraflexure
    let F81_Psc = (F77 * L * Cohesion) / Math.pow(10, 6),
        F81 = F81_Psc;
    let F82_e = De - F77 / 2,
        F82 = F82_e;
    let F84_Psc = (F76 * L * Cohesion) / Math.pow(10, 6),
        F84 = F84_Psc;
    let F85_e = F76 / 2,
        F85 = F85_e;
    let F86_Psc = (Math.pow(De, 2) * Cohesion) / Math.pow(10, 6),
        F86 = F86_Psc;
    let F87_Mr = Math.max(0, (F81 * F82 - F84 * F85) / Math.pow(10, 3)),
        F87 = F87_Mr;

    // Moment resistance from friction on sides of soil wedge
    let F90_wedge_face_area = (Math.pow(F77, 2) * Tanø) / 2 / Math.pow(10, 6),
        F90 = F90_wedge_face_area;
    let F91_Psf = Ka * γ * F90 * Tanø,
        F91 = F91_Psf;
    let F92_e = De - F77 / 3,
        F92 = F92_e;
    let F94_wedge_face_area = (Math.pow(F76, 2) * Tanø) / 2 / Math.pow(10, 6),
        F94 = F94_wedge_face_area;
    let F95_Psf = Ka * γ * F94 * Tanø,
        F95 = F95_Psf;
    let F96_e = F76 / 3,
        F96 = F96_e;
    let F97_Mr = Math.max(0, (F91 * F92 - F95 * F96) / Math.pow(10, 3)),
        F97 = F97_Mr;

    let F99_Nett_load = Fy + F63 / 0.9,
        F99 = F99_Nett_load;
    let F100_eccy = L / 2,
        F100 = F100_eccy;
    let F101_Mr = (F99 * F100) / Math.pow(10, 3),
        F101 = F101_Mr;

    let F103_øMr_about_pier_base = 0.9 * (F78 + F87 + F97 + F101); // < --- RESULT OUTPUT OVERTURNING CHECK

    //BEARING CAPACITY CHECK
    let F110_fy_at_base = Fy + F58,
        F110 = F110_fy_at_base;
    let F111_Eccentricity_about_cl =
            F110_fy_at_base == 0 ? 0 : Math.max(0, ((Mz - (F78 + F87 + F97)) / F110_fy_at_base) * 1000),
        F111 = F111_Eccentricity_about_cl,
        e = F111_Eccentricity_about_cl;
    let F112_bearing_pressure_act = 0;
    if (F110_fy_at_base < 0) {
        F112_bearing_pressure_act = 0;
    } else if (e >= F31 / 2) {
        F112_bearing_pressure_act = 10 * ultimate_bearing_capacity_kPa;
    } else if (e < F31 / 6) {
        F112_bearing_pressure_act = (F110_fy_at_base / A + (F110_fy_at_base * e) / Z) * Math.pow(10, 6);
    } else {
        F112_bearing_pressure_act = ((2 * F110_fy_at_base) / (3 * F31 * (F31 / 2 - e))) * Math.pow(10, 6);
    }
    let F112 = F112_bearing_pressure_act;

    let F113_fs = Adhesion + ((Ka * γ * D) / 2 / 1000) * Tanø,
        F113 = F113_fs,
        fs = F113_fs;
    let F114_Bearing_pressure_allow = ultimate_bearing_capacity_kPa + (fs * D) / 1000,
        F114 = F114_Bearing_pressure_allow;

    let F115_bearing_capacity_check = L * D == 0 ? 0 : F112 > F114 ? 1 : 0;

    // TORSION RESISTANCE CHECK

    let F117_perimeter = (circular ? PI() * F19 : 4 * F19) * (F22 - depth_of_ineffective_soil_mm),
        F117 = F117_perimeter;
    let F118_shear_resistance = 0.5 * Cohesion,
        F118 = F118_shear_resistance;
    let F119_friction_resistance = (Ka * γ * Tanø * (F22 + B6)) / 2 / 1000,
        F119 = F119_friction_resistance;
    let F120_torsion_lever = circular ? F19 / 2 : F19 / 2,
        F120 = F120_torsion_lever; //=IF(F12=Square,F19/2,IF(F12=Circular,F19/2,(F17+F19)/4))
    let F121_total_torsional_resistance =
            (Math.max(F118_shear_resistance, F119_friction_resistance) * F117 * F120) / Math.pow(10, 9),
        F121 = F121_total_torsional_resistance;

    // PIER STRENGTH

    let F124_Z = Z / Math.pow(10, 6),
        F124 = F124_Z;
    let F125_fcf = Math.pow(Fc, 0.5) * 0.6,
        F125 = F125_fcf;
    let F126_øMcr = (0.6 * Z * F125) / Math.pow(10, 6),
        F126 = F126_øMcr;
    let F127_ast_required = 0;
    if (F126 > Math.abs(Mz)) {
        F127_ast_required = 0;
    } else if (circular) {
        F127_ast_required = (Math.abs(Mz) * Math.pow(10, 6)) / (0.72 * 0.7 * L * 400);
    } else {
        F127_ast_required = (Math.abs(Mz) * Math.pow(10, 6)) / (0.72 * 0.7 * B * 400);
    }

    let result = {
        "uplift_check_øG_(max)": F63_øG_max_kN,
        "uplift_check_øG_(max)_capacity": F46,
        "uplift_check_øG_(max)_ratio": -F46 / F63_øG_max_kN,
        overturning_check_øMr_about_pier_base: F103_øMr_about_pier_base,
        overturning_check_øMr_about_pier_base_capacity: F66_Mo_about_pier_base,
        overturning_check_øMr_about_pier_base_ratio: F66_Mo_about_pier_base / F103_øMr_about_pier_base,
        bearing_capacity_check_pressure_actual: F112_bearing_pressure_act,
        bearing_capacity_check_pressure_capacity: F114_Bearing_pressure_allow,
        bearing_capacity_check_pressure_ratio: F112_bearing_pressure_act / F114_Bearing_pressure_allow,
        torsion_resistance_check: F121_total_torsional_resistance,
        torsion_resistance_check_capacity: F115_bearing_capacity_check,
        torsion_resistance_check_ratio: F115_bearing_capacity_check / F121_total_torsional_resistance,
        pier_strength: F127_ast_required, // not seeming to be used in spreadsheet
    };

    result["valid"] =
        result["uplift_check_øG_(max)_ratio"] < 1 &&
        result["overturning_check_øMr_about_pier_base_ratio"] < 1 &&
        result["bearing_capacity_check_pressure_ratio"] < 1 &&
        result["torsion_resistance_check_ratio"] < 1;
    return result;
};

export const deckEngineering_test = () => {
    if (window.calculateDeckBeamCapacity_tested) return;
    window.calculateDeckBeamCapacity_tested = true;

    let expected_result = {
        ratio_G: 384,
        capacity_G: 1.56,
        ratio_Q_UDL: 115,
        capacity_Q_UDL: 3.46,
        ratio_Q_P: 195,
        capacity_Q_P: 2.05,
        ratio_G_04Q: 165,
        capacity_G_04Q_mm: 2.42,
    };

    let test_result = calculateDeckBeamCapacity("Bearer", "656510", 2700, 900);

    for (let key in expected_result) {
        if (
            (key.includes("ratio") && Math.abs(expected_result[key] - test_result[key]) > 1) ||
            (key.includes("capacity") && Math.abs(expected_result[key] - test_result[key]) > 0.01)
        ) {
            alert(
                "test failed at calculateDeckBeamCapacity_test:" +
                    key +
                    " .. " +
                    expected_result[key] +
                    " vs " +
                    test_result[key]
            );
            //
            //
            return;
        }
    }

    expected_result = {
        ratio_G: 317,
        capacity_G: 1.57,
        ratio_Q_UDL: 95,
        capacity_Q_UDL: 4.2,
        ratio_Q_P: 489,
        capacity_Q_P: 0.81,
        ratio_G_04Q: 136,
        capacity_G_04Q_mm: 2.94,
    };
    test_result = calculateDeckBeamCapacity("Joist", "FL15015", 3700, 2000);

    for (let key in expected_result) {
        if (
            (key.includes("ratio") && Math.abs(expected_result[key] - test_result[key]) > 1) ||
            (key.includes("capacity") && Math.abs(expected_result[key] - test_result[key]) > 0.01)
        ) {
            alert(
                "test failed at calculateDeckBeamCapacity_test:" +
                    key +
                    " .. " +
                    expected_result[key] +
                    " vs " +
                    test_result[key]
            );
            return;
        }
    }

    let expected_load = 37.2;
    if (Math.abs(expected_load - calculateDeckLoadFromM2(10)) > 1)
        alert("test failed at calculateDeckLoadFromM2:" + expected_load + " vs " + calculateDeckLoadFromM2(10));

    expected_load = 41.13;
    if (Math.abs(expected_load - calculateDeckLoadFromM2(10, 7.08)) > 1)
        alert("test failed at calculateDeckLoadFromM2:" + expected_load + " vs " + calculateDeckLoadFromM2(10));

    expected_load = 2.3106;
    if (Math.abs(expected_load - calculate_ColCapacity("65mm x 65mm x 3mm P/C", 3000, 10, 7.08)) > 0.01)
        alert(
            "test failed at calculate_ColCapacity:" +
                expected_load +
                " vs " +
                calculate_ColCapacity("65mm x 65mm x 3mm P/C", 3000, 10, 7.08)
        );

    expected_result = {
        "uplift_check_øG_(max)": 4.47,
        "uplift_check_øG_(max)_capacity": 26.04,
        overturning_check_øMr_about_pier_base: 7.47,
        overturning_check_øMr_about_pier_base_capacity: 0,
        bearing_capacity_check_pressure_actual: 141,
        bearing_capacity_check_pressure_capacity: 150,
        torsion_resistance_check: 0.41,
        torsion_resistance_check_capacity: 0,
        pier_strength: 0,
    };
    test_result = calculate_FootingCapacity(26.04, false, 450, 500, soil_types.B);

    for (let key in expected_result) {
        if (
            (expected_result[key] > 5 && Math.abs(expected_result[key] - test_result[key]) > 1) ||
            (expected_result[key] < 5 && Math.abs(expected_result[key] - test_result[key]) > 0.01)
        ) {
            alert(
                "deck test failed at calculate_FootingCapacity:" +
                    key +
                    " .. " +
                    expected_result[key] +
                    " vs " +
                    test_result[key]
            );
            return;
        }
    }
};
